module.exports = __webpack_public_path__ + "static/img/upright-interpretive-sign.459b7db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/graphic-panels/upright-interpretive-sign.jpg
// module id = 665
// module chunks = 0